/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { pick } from 'ramda'
import React from 'react'

import { Absolute, Relative } from '../helpers/Position'
import { applyStyle } from '../../utils/helpers/styles'
import { useInputStyle } from '../../utils/styles/input'
import { useSizeStyle } from '../../utils/styles/size'
import Center from '../helpers/Center'
import Icon from '../shapes/Icon'

const XInput = ({ placeholder, value, onChange, iconRight, iconLeft, ...props }) => {
  const style = css`
    ${useInputStyle(props)}
    ${useSizeStyle(props)}
    ${applyStyle('padding-right', iconRight, '2rem')}
    ${applyStyle('padding-left', iconLeft, '2rem')}
  `

  const handleChange = e => {
    if (onChange) onChange(e.target.value)
  }

  const handleBlur = e => {
    if (value) onChange(e.target.value.trim())
  }

  return (
    <Relative zIndex={1}>
      {iconLeft && (
        <Absolute left={0.6} top={0} bottom={0} zIndex={1}>
          <Center height="100%">
            <Icon name={iconLeft} color="dark2" />
          </Center>
        </Absolute>
      )}

      <input
        className="input"
        css={style}
        placeholder={placeholder}
        value={value || ''}
        onChange={handleChange}
        onBlur={handleBlur}
        {...pick(
          [
            'onSubmit',
            'onFocus',
            'onKeyUp',
            'onKeyPress',
            'onKeyDown',
            'type',
            'autocomplete',
            'disabled',
            'autoFocus'
          ],
          props
        )}
      />

      {iconRight && (
        <Absolute right={0.6} top={0} bottom={0} zIndex={1}>
          <Center height="100%">
            <Icon name={iconRight} color="dark2" />
          </Center>
        </Absolute>
      )}
    </Relative>
  )
}

export default XInput
